<form [id]="'star_rating' + type">
<fieldset class="star-rating">
    <legend class="sr-only">Star Rating</legend>
    <span *ngFor="let i of [1, 2, 3, 4, 5]" class="star">
      <input
        type="radio"
        [id]="'star-'+type+ i"
        [name]="'star-rating'"
        [value]="i"
        [checked]="rating === i"
        (change)="changeRating(i)"
      />
      <label [for]="'star-' + i" [ngClass]="{'filled': rating >= i}">&#9733;</label>
    </span>
    <output class="output">{{ratingText}}</output>
  </fieldset>
</form>